/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Demo_TitleInputs */

const en_ui_onboarding_demo_title = /** @type {(inputs: Ui_Onboarding_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try demo data`)
};

const de_ui_onboarding_demo_title = /** @type {(inputs: Ui_Onboarding_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo ansehen`)
};

/**
* | output |
* | --- |
* | "Try demo data" |
*
* @param {Ui_Onboarding_Demo_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_demo_title = /** @type {((inputs?: Ui_Onboarding_Demo_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Demo_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_demo_title(inputs)
	return de_ui_onboarding_demo_title(inputs)
});